import { RootState } from "store";

const getFees = (state: RootState) => state.fees;

export const feesDataSelector = (state: RootState) => getFees(state).data;
export const feesAlertsSelector = (state: RootState) => getFees(state).alerts;
export const feesLoadersSelector = (state: RootState) => getFees(state).loaders;
